import { render, staticRenderFns } from "./DetalheAdicional.vue?vue&type=template&id=92d1ecc8&scoped=true"
import script from "./DetalheAdicional.vue?vue&type=script&lang=js"
export * from "./DetalheAdicional.vue?vue&type=script&lang=js"
import style0 from "./DetalheAdicional.vue?vue&type=style&index=0&id=92d1ecc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d1ecc8",
  null
  
)

export default component.exports